import * as types from 'generated/graphql';
import { DocumentNode } from 'graphql';



export interface IRefetchQuery<TVariables> {
  query: DocumentNode;
  variables: TVariables;
}

export type FnRefetchQuery<TVariables> = (variables: TVariables) => IRefetchQuery<TVariables>;

export const EditPaymentSection: FnRefetchQuery<types.EditPaymentSectionQueryVariables> = variables => ({
  query: types.EditPaymentSectionDocument,
  variables
});



export const MyFundraisesActivity: FnRefetchQuery<types.MyFundraisesActivityQueryVariables> = variables => ({
  query: types.MyFundraisesActivityDocument,
  variables
});
